module.exports = __webpack_public_path__ + "img/banking-compare.65ae090.webp";